<template>
    <travel-card-list :travel-cards="travelCardsList" :card-type="cardType" :is-loading="isLoading" />
</template>

<script setup lang="ts">
import { computed, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { getCardsByCardType } from '@/helpers';
import TravelCardList from '../components/list/TravelCardList.vue';
import { useCardStore } from '../store/cardStore';
import { ITravelCardPage, TravelCardDto } from '../types';

const props = defineProps<ITravelCardPage>();

const cardStore = useCardStore();
const { items, isLoading } = storeToRefs(cardStore);

const travelCardsList = computed(() => getCardsByCardType(items.value as TravelCardDto[], props.cardType, props.take));

onMounted(async () => await cardStore.getAllTravelCards());
</script>
